(function() {
'use strict';

angular.module('TR')
    .controller('Departure', Departure);

function Departure($scope, searchUnitService, $window) {
    const cm = this;

    cm.loading = true;
    cm.setDepartureAirport = setDepartureAirport;

    searchUnitService.getAvailableDepartureAirports()
        .then(function(airports) {
            cm.departureAirports = airports;
            cm.loading = false;
        }, function(msg) {
            $scope.$emit('flash:error', msg);
        });


    function setDepartureAirport(a) {
        a.clicked = true;
        searchUnitService.setDepartureAirports(a);
        a.clicked = false;
        setTimeout(function() {
            $window.history.back();
        }, 0);
    }
}
})();
